import { Node_Type } from 'ricos-schema';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const modalContentStyles = {
  width: 363,
  padding: 20,
  boxSizing: "border-box",
  border: "solid 1px rgba(51, 51, 51, 0.1)",
  borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
  boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))"
};
const videoModalContentStyles = __spreadValues({
  height: 232
}, modalContentStyles);
const embedModalContentStyles = __spreadValues({
  height: 180
}, modalContentStyles);
const videoModals = {
  insertVideo: `${Node_Type.VIDEO}.insertVideo`,
  insertYoutube: `${Node_Type.VIDEO}.insertYoutube`,
  replace: `${Node_Type.VIDEO}.replace`,
  settings: `${Node_Type.VIDEO}.settings`
};
const VIDEO_BUTTONS = {
  alignment: `${Node_Type.VIDEO}.alignment`,
  size: `${Node_Type.VIDEO}.size`
};
const pauseTrigger = { scroll: "scroll" };

export { VIDEO_BUTTONS, embedModalContentStyles, pauseTrigger, videoModalContentStyles, videoModals };
//# sourceMappingURL=constants.js.map
